import React from "react";
import "../../App.css";

// Back to Products Button
function BackToProductsButton({ handleNavClick }) {
  return (
    <div className="back-to-products">
      <button
        className="back-arrow-btn"
        onClick={() => handleNavClick("products-landing")}
        aria-label="Back to Products"
      >
        <span className="arrow-icon">←</span>
        <span className="back-text">Back to Products</span>
      </button>
    </div>
  );
}

// Back to Industry Verticals Button
function BackToIndustryVerticalsButton({ handleNavClick }) {
  return (
    <div className="back-to-industry-verticals">
      <button
        className="back-arrow-btn"
        onClick={() => handleNavClick("services-landing")}
        aria-label="Back to Industry Verticals"
      >
        <span className="arrow-icon">←</span>
        <span className="back-text">Back to Industry Verticals</span>
      </button>
    </div>
  );
}


export { BackToProductsButton, BackToIndustryVerticalsButton };